export default __webpack_public_path__ + "static/media/gif.3b548d30.svg";